namespace $.$$ {

	$mol_style_define( $shm_button_copy, {

		Bubble: {
			pointerEvents: 'none',
		},

		Status: {
			padding: {
				left: $mol_gap.text,
				right: $mol_gap.text,
			},
			background: {
				color: $mol_theme.back,
			},
			color: $mol_theme.shade,
			whiteSpace: 'nowrap',

			'[copied]': {
				true: {
					color: $mol_theme.text,
				},
			},
		},

	} )
}
